import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { getSingleEntitySchema, buildPropsQuery } from '@blaze-cms/react-page-builder';
import { MainContext } from '@blaze-cms/nextjs-components';
import GTMRender from './GTMRender';
import { getRenderProps, buildPropsToDisplayArray } from '../helpers';
const GTMFactory = ({
  propsToDisplay,
  userPropsToDisplay,
  parent,
  gtmWebVitals
}) => {
  const {
    isPreview
  } = useContext(MainContext);
  const {
    data,
    error,
    loading
  } = useQuery(getSingleEntitySchema, {
    variables: {
      id: parent.itemEntity
    }
  });
  if (typeof window === 'undefined') return null;
  if (loading || error || !data) return null;
  const propsToDisplayArr = buildPropsToDisplayArray(propsToDisplay);
  const extraProps = buildPropsQuery(data, propsToDisplayArr) || '';
  const {
    action,
    actionKey
  } = getRenderProps(extraProps, isPreview, data);
  return /*#__PURE__*/React.createElement(GTMRender, {
    action: action,
    actionKey: actionKey,
    userPropsToDisplay: userPropsToDisplay,
    propsToDisplay: propsToDisplay,
    parentId: parent.itemId,
    webVitals: gtmWebVitals
  });
};
GTMFactory.propTypes = {
  propsToDisplay: PropTypes.array,
  userPropsToDisplay: PropTypes.array,
  parent: PropTypes.object.isRequired,
  gtmWebVitals: PropTypes.bool
};
GTMFactory.defaultProps = {
  propsToDisplay: [],
  userPropsToDisplay: [],
  gtmWebVitals: false
};
export default GTMFactory;
//# sourceMappingURL=GTMFactory.js.map